import { render } from "./InputBoxPairs.vue?vue&type=template&id=dce26e38&scoped=true&lang=pug"
import script from "./InputBoxPairs.vue?vue&type=script&lang=js"
export * from "./InputBoxPairs.vue?vue&type=script&lang=js"

import "./InputBoxPairs.vue?vue&type=style&index=0&id=dce26e38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dce26e38"]])

export default __exports__